<template>
	<section
		class="pricing section"
		:class="[
			topOuterDivider && 'has-top-divider',
			bottomOuterDivider && 'has-bottom-divider',
			hasBgColor && 'has-bg-color',
			invertColor && 'invert-color',
		]"
	>
		<div class="container">
			<div
				class="pricing-inner section-inner"
				:class="[
					topDivider && 'has-top-divider',
					bottomDivider && 'has-bottom-divider',
				]"
			>
				<c-section-header
					:data="sectionHeader"
					class="center-content invert-color"
				/>
				<div class="tiles-wrap" :class="[pushLeft && 'push-left']">
					<div class="tiles-item reveal-from-top" data-reveal-delay="400">
						<div
							class="tiles-item-inner has-shadow"
							style="border-radius: 28px; padding-top: 1.5rem"
						>
							<div class="pricing-item-content">
								<div class="pricing-item-header pb-10 mb-24">
									<div class="pricing-item-price mb-4">
										<span class="pricing-item-price-amount h1">$0.05</span>
									</div>
									<div
										v-if="priceChangerValue != 3"
										class="text-color-low text-xs"
									>
										per lead
									</div>
								</div>
								<div class="pricing-item-features mb-40">
									<ul
										class="pricing-item-features-list list-reset text-xs mb-32"
									>
										<li class="is-checked">First 500 leads free</li>
										<li class="is-checked">Fresh lead lists in 24 hours</li>
										<li class="is-checked">Data request API</li>
										<li class="is-checked">7-day data retention</li>
										<li class="is-checked">High volume discounts available</li>
									</ul>
								</div>
							</div>
							<div class="pricing-item-cta mb-8">
								<c-button tag="a" color="primary" wide href="/signup"
									><div style="display: flex;"><span>Get started</span><span style="font-family: 'Material Icons';" class="ml-12">chevron_right</span></div></c-button
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { SectionTilesProps } from "@/utils/SectionProps.js";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
import CButton from "@/components/elements/Button.vue";

export default {
	name: "CPricing",
	components: {
		CSectionHeader,
		CButton,
	},
	mixins: [SectionTilesProps],
	props: {
		pricingSwitcher: {
			type: Boolean,
			default: false,
		},
		pricingSlider: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			sectionHeader: {
				title: "Flat, usage-based pricing",
				paragraph:
					"We extract contacts on-demand from users associated with public code repositories related to your products.",
			},
			priceChangerValue: 0,
			priceInput: {
				0: "1,000 leads",
				1: "10k leads",
				2: "100k leads",
				3: "1M+",
			},
			priceOutput: {
				plan1: {
					0: ["$50"],
					1: ["$500"],
					2: ["$5000"],
					3: ["Contact us"],
				},
			},
		};
	},
	methods: {
		handlePricingSlide(e) {
			this.handleSliderValuePosition(e.target);
		},
		handleSliderValuePosition(input) {
			const multiplier = input.value / input.max;
			const thumbOffset = this.thumbSize * multiplier;
			const priceInputOffset =
				(this.thumbSize - this.$refs.sliderValue.clientWidth) / 2;
			this.$refs.sliderValue.style.left =
				input.clientWidth * multiplier - thumbOffset + priceInputOffset + "px";
		},
		getPricingData(values, set) {
			return set !== undefined
				? values[this.priceChangerValue][set]
				: values[this.priceChangerValue];
		},
	},
	mounted() {
		if (this.pricingSlider) {
			this.$refs.slider.setAttribute("min", 0);
			this.$refs.slider.setAttribute(
				"max",
				Object.keys(this.priceInput).length - 1
			);
			this.thumbSize = parseInt(
				window
					.getComputedStyle(this.$refs.sliderValue)
					.getPropertyValue("--thumb-size"),
				10
			);
			this.handleSliderValuePosition(this.$refs.slider);
		}
	},
};
</script>